import { urlIsValid } from 'helpers/validate';
import { model } from 'helpers/model';

const appPkgComponentModel = {
  fields: ['appSwitcherShortcut', 'oauth2RedirectUrl', 'contextMenuExtension'],

  requiredFields: [
    'appSwitcherShortcut',
    'oauth2RedirectUrl',
    'contextMenuExtension'
  ],

  initialValues: {},

  validate: field => values => {
    const validations = {
      appSwitcherShortcut: !window.URL // ie11
        ? undefined
        : urlIsValid(values['appSwitcherShortcut'])
          ? undefined
          : 'Must be a valid URL including protocol',
      oauth2RedirectUrl: !window.URL // ie11
        ? undefined
        : urlIsValid(values['oauth2RedirectUrl'])
          ? undefined
          : 'Must be a valid URL including protocol'
    };

    return validations[field] ? { [field]: validations[field] } : {};
  }
};

export default model(appPkgComponentModel);



// WEBPACK FOOTER //
// ./src/client/modules/application/app-package-model.js